export default "__VITE_ASSET__BEkLZzwH__"